export default __webpack_public_path__ + "static/media/box3.7b0ad20e.jpg";